module.exports = __webpack_public_path__ + "img/shouchi.a19109d7.png";